<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="marquee" style="padding:10px;text-align: center ">
        <i class="el-icon-warning-outline" style="font-size: 18px;margin-right: 5px;"/>公告：默认样品保管时间为检测完成后1个月内，逾期将清理销毁。如需回收样品请及时申请。
      </div>

      <!-- 主内容布局 -->
      <div class="content-wrapper">
        <!-- 左侧菜单 -->
        <div class="menu-container">
          <el-menu
            :default-active="active"
            active-text-color="#2F66F3"
            background-color="#f8f9fa"
            mode="vertical"
            router
            text-color="#4a5568"
            class="sidebar-menu"
          >
            <el-menu-item
              style="background-color: #ffffff;"
              v-for="menu in menus"
              :key="menu.value"
              :index="menu.value"
            >
              {{ menu.label }}
            </el-menu-item>
          </el-menu>
        </div>

        <!-- 右侧内容区 -->
        <div class="content-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPhone, getPortrait, getUserName, removeToken, setPortrait, setUserName } from '@/utils/auth'
import {getCosConfig, getPresignDownloadUrl, uploadImageFileByUserId} from '@/api/upload'
import {newUpdateUser, updateUser} from '@/api/user'
import Cos from 'cos-js-sdk-v5'
import { isMember, isMemberAdmin } from '@/api/member'
import NavBar from '@/layouts/NavBar.vue'

export default {
  name: 'UserLayout',
  components: { NavBar },
  data() {
    return {
      menus: [
        { label: '我的订单', value: '/user/orders' },
        { label: '样品邮寄', value: '/user/system-courier' },
        { label: '我要咨询', value: '/user/consulting-service' },
        { label: '系统消息', value: '/user/system-message' },
        { label: '送检流程', value: '/user/submission' },
        { label: '邮寄地址', value: '/user/mailingAddress' },
        { label: '致谢奖励', value: '/user/thankReward' },
        { label: '测试评价', value: '/user/appraise' }
      ],
      dialogVisible: false,
      userDate: {
        username: '',
        portrait: []
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }]
      }
    }
  },
  computed: {
    active() {
      const result = this.menus.find(item => this.$route.path.indexOf(item.value) > -1)
      return result ? result.value : ''
    }
  },
  methods: {
    loginOut() {
      removeToken()
      this.$message.success('退出成功')
      setTimeout(() => {
        this.$router.push({ name: 'wxLogin' })
      }, 1000)
    },
    customRequest(res) {
      this.disable = true

      // 1. 创建 FormData 对象
      const formData = new FormData()
      formData.append('imgFile', res.file)

      // 2. 上传文件到后端
      uploadImageFileByUserId(formData).then(response => {
        if (response.code === 200) {
          // 3. 后端返回的是 KEY（文件路径），不是完整URL
          const key = response.data  // 例如："20231220-12345-avatar.jpg"

          // 4. 获取签名下载链接（不能省略！）
          getPresignDownloadUrl(key).then(result => {
            console.log('签名URL:', result)

            // 5. 使用签名URL更新头像
            const signedUrl = result.data
            res.file.Location = signedUrl
            this.userDate.portrait[0] = {
              url: signedUrl
            }

            this.$emit('success', res.file)
            this.$message.success('上传成功')
          })
        } else {
          this.$message.error('上传失败')
        }
      }).catch(error => {
        console.error('上传失败:', error)
        this.$message.error('上传失败')
      }).finally(() => {
        this.disable = false
      })
    },
    uploadSuccess(res, file, filelist) {
      console.log('成功返回', filelist)
    },
    handleRemove(file, fileList) {
      this.userDate.portrait = fileList
    },
    save() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          let formData = new FormData()
          formData.append('userName', this.userDate.username)
          if (this.userDate.portrait[0]) {
            formData.append('portrait', this.userDate.portrait[0].url)
          }
          newUpdateUser(formData).then(res => {
            if (res.code === 200) {
              setUserName(res.data.username)
              setPortrait(res.data.portrait)
              this.dialogVisible = false
              location.reload()
            } else {
              this.$message.error('修改失败')
            }
          })
        }
      })
    },
    judgeIsMemberAdmin() {
      isMemberAdmin().then(res => {
        if (res.code === 200 && res.data === false) {
          this.menus = this.menus.filter(item => item.value !== '/user/accountManagement')
        }
      })
      isMember().then(res => {
        if (res.code === 200 && res.data === false) {
          this.menus = this.menus.filter(item => item.value !== '/user/consumption-records')
        }
      })
    },
    refresh() {
      location.reload()
    },
    update() {
      this.userDate.username = getUserName() !== 'null' && getUserName() ? getUserName() : ''
      this.userDate.portrait[0] = getPortrait() !== 'null' && getPortrait() ? { url: getPortrait() } : {}
      this.dialogVisible = true
    }
  },
  created() {
    this.userName = getUserName() !== 'null' && getUserName() ? getUserName() : '点击完善您的个人信息'
    this.phone = getPhone(true)
    this.portrait = getPortrait()
    if (getPortrait()) {
      this.userDate.portrait[0] = { url: getPortrait() }
    }
    getCosConfig().then(res => {
      this.config = res.data
    })
    this.cosInstance = new Cos({
      Protocol: 'https:',
      getAuthorization: (options, callback) => {
        getCosConfig().then(res => {
          this.config = res.data
          const data = res.data
          callback({
            TmpSecretId: data.secretId,
            TmpSecretKey: data.secretKey,
            XCosSecurityToken: data.token,
            StartTime: data.StartTime,
            ExpiredTime: data.expiredTime
          })
        })
      }
    })
    this.judgeIsMemberAdmin()
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  padding-top: 10px;
  min-height: calc(100vh - 80px);
  background: #f5f7fa;
}

.marquee {
  color: #fd6c0c;
  overflow: hidden; /* 隐藏超出容器大小的内容 */
  animation-name: marquee;
  animation-duration: 20s; /* 动画持续时间 */
  animation-timing-function: linear; /* 线性变化速度 */
  animation-iteration-count: infinite; /* 无限次重复动画 */
  width: 70%;
  margin-left: 30%;
}

@keyframes marquee {
  0% { transform: translateX(0); }
  50% { transform: translateX(-30%); }
  100% { transform: translateX(0); }
}

.content-wrapper {
  display: flex;
  max-width: 1200px;
  margin-left: 210px; /* 居中显示内容 */
  gap: 0;
}

/* —————— 左侧菜单 —————— */
.menu-container {
  width: 200px;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: fit-content;
  background: #f8f9fa; /* 确保.el-menu的背景颜色是#f8f9fa */
  position: -webkit-sticky; /* Safari兼容性 */
  position: sticky;
  top: 10px;
}
.sidebar-menu {
  border-right: none !important;
  box-shadow: none !important;

  .el-menu-item {
    height: 48px;
    background-color: #ffffff !important; /* 强制.el-menu-item的背景颜色是#ffffff */
    line-height: 48px;
    padding: 0 24px !important;
    margin: 4px 8px;
    border-radius: 6px;
    transition: all 0.2s ease;
    font-size: 14px;

    &:hover {
      background-color: #eef4ff !important;
      color: #2f66f3 !important;
    }

    &.is-active {
      background-color: #eef4ff !important;
      color: #2f66f3 !important;
      font-weight: 500;
    }
  }
}

.refresh-btn {
  padding: 12px 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #646c7a;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: auto;
  border-top: 1px solid #eee;
  background: #f1f3f5;

  i {
    font-size: 14px;
  }

  &:hover {
    background: #eef4ff;
    color: #2f66f3;
  }
}

/* —————— 右侧内容区 —————— */
.content-container {
  flex: 1;
  background: #ffffff;
  //border-radius: 12px;
  //box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  min-height: 600px;
  padding: 24px;
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/layouts/UserLayout.vue